import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Heatmap from "../../../../components/charts/heatMap/heatMap";
import { actionCreators } from "../redux/serviceBookingsSagas";
import { selectChartControlsDisabled } from "../redux/serviceBookingsSelectors";

function reOrderDays(series) {
  const clonedSeries = series.slice(0);

  return clonedSeries.map((item) => {
    if (item.data[0].toolTipData.includes("Sunday")) {
      item.data.push(item.data.shift());
    }

    return item;
  });
}

const HeatMapChart = ({ groupByTimeOfDaySeries, categories }) => {
  const dispatch = useDispatch();
  const isUserQa = useSelector((state) => state.serviceBookings.currentUser.qa);
  const series = useSelector((state) => state.serviceBookings.series);
  const tableDataLoading = useSelector((state) => state.serviceBookings.tableDataLoading);
  const modalTableData = useSelector((state) => state.serviceBookings.modalTableData);
  const groupByTimeOfDay = useSelector((state) => state.serviceBookings.groupByTimeOfDay);
  const chartControlsDisabled = useSelector(selectChartControlsDisabled);
  const seriesProps =
    groupByTimeOfDaySeries !== undefined ? groupByTimeOfDaySeries : reOrderDays(series);

  const chartSettings = {
    categories: categories,
    heatMapRadius: 15,
    stroke: 0.5,
    series: seriesProps,
    tableDataLoading,
    modalTableData,
    isUserQa,
    groupByTimeOfDay: groupByTimeOfDay,
    disabled: chartControlsDisabled,
    modalProps: {
      progressInPercent: false,
      mainMetricTitle: "Service Bookings",
      detailsTitle: "Service Bookings Details",
      tableHeight: 320,
      hideProgress: true
    }
  };

  const handleDataClick = (tableDataUid) => {
    let data = {
      tableDataUid
    };
    dispatch(actionCreators.getTableData(data));
  };

  return <Heatmap {...chartSettings} handleDataClick={handleDataClick} />;
};

export default HeatMapChart;
